import {theme} from "./Tema";

export const VALORENVIOGRATIS = 350000

export const ESTADOSCURSO = [
    {
        nombre: 'Publicado',
        color: theme.palette.primary.main
    },
    {
        nombre: 'Archivada',
        color: theme.palette.secondary.main
    },
]


export const ESTADOSMAYORISTAS = [
    {
        nombre: 'Nuevo',
        color: '#EA3224'
    },
    {
        nombre: 'Seguimiento',
        color: '#232323'
    },
    {
        nombre: 'Archivado',
        color: '#5c5c5c'
    },
]


export const ESTADOSPOTENCIALES = [
    {
        nombre: 'Nuevo',
        color: '#EA3224'
    },
    {
        nombre: 'Contactado',
        color: '#5f9658'
    },
    {
        nombre: 'Registrado',
        color: '#303376'
    },
    {
        nombre: 'Archivado',
        color: '#5c5c5c'
    },
]

export const ESTADOSCLIENTESPOTENCIALES = [
    {
        nombre: 'Nuevo',
        color: '#EA3224'
    },
    {
        nombre: 'Contactado',
        color: '#5f9658'
    },
    {
        nombre: 'Activo',
        color: '#303376'
    },
    {
        nombre: 'Archivado',
        color: '#5c5c5c'
    },
]

export const LOCALES = [
    {
        nombre: 'Puenes',
        color: '#FFB100'
    },
    {
        nombre: 'Parque 20 de Julio',
        color: '#E30033'
    },
    {
        nombre: 'Carrera 11',
        color: '#5c5c5c'
    }
]







export const ESTADOSUSUARIOS = [
    {
        nombre: 'Solicitante',
        color: theme.palette.primary.main
    },
    {
        nombre: 'Admin',
        color: theme.palette.secondary.main
    },
    {
        nombre: 'Suspendido',
        color: theme.palette.info.main
    },
]

export const ESTADOSPQRS = [
    {
        nombre: 'Nuevo',
        color: '#EA3224'
    },
    {
        nombre: 'Contactado',
        color: '#5f9658'
    },
    {
        nombre: 'Atendido',
        color: '#303376'
    },
    {
        nombre: 'Archivado',
        color: '#5c5c5c'
    },
]

export const TIPOSPQRS = [

    {
        nombre: 'Peticion'
    },
    {
        nombre: 'Queja'
    },
    {
        nombre: 'Solicitud'
    },
    {
        nombre: 'Felicitacion'
    },
]


export const TIPOSPERFILACION = [

    {
        nombre: 'Insolvencia Económica'
    },
    {
        nombre: 'Conciliación'
    },
    {
        nombre: 'Arbitraje o Arbitraje Ejecutivo'
    },
    {
        nombre: 'Accidentes de Tránsito'
    },
    {
        nombre: 'Oferta Educativa'
    },
    {
        nombre: 'Otro Asunto'
    },
]